import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ceo-page',
    templateUrl: './ceo-page.component.html',
    styleUrls: ['./ceo-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CeoPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
